<mat-dialog-content>
  <form [formGroup]="form" class="row">
    <div class="input-wrapper">
      <mat-form-field appearance="outline">
        <mat-label>Feed Url</mat-label>
        <input
          matInput
          type="text"
          formControlName="url"
          placeholder="http://example.com/rss?lang=fr"
          (keyup.enter)="submit()"
        />
      </mat-form-field>
    </div>
    <div class="input-wrapper col-md-6">
      <mat-form-field appearance="outline">
        <mat-label>Type of RSS Feed (for validation only)</mat-label>
        <mat-select formControlName="newsRssFeedType">
          <mat-option
            *ngFor="let rssFeedType of availableNewsRssFeedTypes"
            [value]="rssFeedType"
          >
            {{ rssFeedType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-4 provider-validate-button">
      <button
        type="button"
        [disabled]="loading"
        (click)="validateFeed()"
        mat-raised-button
        color="primary"
      >
        Validate feed
      </button>
    </div>

    <div *ngIf="loading" class="col-md-12 row justify-content-center">
      <mat-spinner></mat-spinner>
    </div>
  </form>

  <section *ngIf="!loading && validated">
    <app-rss-validator-form-errors
      [results]="results"
    ></app-rss-validator-form-errors>
  </section>
</mat-dialog-content>

<div class="save-button-container mt-2">
  <button class="ml-1" (click)="close()" mat-flat-button>Cancel</button>

  <button
    [disabled]="loading"
    (click)="submit()"
    class="ml-1"
    mat-raised-button
    color="primary"
  >
    {{ buttonText }}
  </button>
</div>
